var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrintingAndPacking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.25,
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_354_1469",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_354_1469",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACeklEQVR4nO3dTW7TQBiAYW/aEyCh8lOp8xWQDGjGmvkKR4A1gjMUtSdj1QXlBkAFlEPAAiHEpu2+yBGtSPizY4/1xX4fKTvHkeftTDKVoxQFAAAAAAAAAGACtqr0REL6LkHPeejSY+BC+uxCetw5iPj0hRDayx+jC/qpexBmxnmfY0CQMPIgnU84MUIQWwhiDEGMIYgxBDFmNEHKslwXH/dd0CMX9KyHTdmZ8+mt+LRXn3uo6xhFkDtVdc0F/ZhrL+CCHm/GuDHEtax8kLIs13PGuHz49CHGuJb7elY+iPi4P8SO+edMeZ79elY9iAt6NP+a6eUt//B61/Nu39+5IV4P54L49KbIbAxBTn99vXog+zq33E0352dIOunr3CMOkk4IYnnJ8nrYxyyZzQ6vr1iy2g6cT3uDvalXupv9ekbysfc4exCv7/jY29BmjBv1PiFfjPSejWFLMca1ep/gvL5e/OS11PIU9HR2rkp3h5gZo1myxoYgxhDEGIIYQxBjCGIMQYwhiDEEMYYgxhDEGIIYQxBjCGIMQYwhiDEEMYYgxhDEGIIYQ5AWxOuz7bDzNNfxs+dwk0Mzt2O8IiF9dV6/bd17cLXv4y8QpCEX0ovLW4S8HvR9/AWCNFx6FgfqX0tR2+PnnsuS1Wzp+e1Gur8sRW2PX0SQFkvPHwb5oOvxiwjSUNuBWnZgCdIQQYwRZogtQhBbhCC2CEGmSdgY2kKQ/+j7+4ptX6/oamxfaROC2CIEsUUIMm3Ce4gtBDGGIMYQxBiCGEMQYwgytSA8NOv/vggSVixI/etizAq186Ng9U+91SciinaOIZU+6hwEAAAAAAAAAFDY9wMA2I1SbRnRZwAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintingAndPacking);
export default __webpack_public_path__ + "static/media/printingAndPacking.5f63943d5ad6a0540c11a120b59694b5.svg";
export { ForwardRef as ReactComponent };